import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';


@Injectable({
  providedIn: 'root'
})
export class CrewScheduleService {
  get baseUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getGroups(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Common/GetGroup', data);
  }

  SubmitCrewSchedule(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/SubmitCrewSchedule', data);
  }

  async GetCrewScheduleList(data: any): Promise<any[]> {
    return await this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetCrewScheduleList', data).toPromise();
  }

  GetCrewScheduleData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetCrewScheduleList', data);
  }

  GetUserManagerList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'Account/GetUserManagerList', data);
  }

  CrewUserType(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/CrewUserType', data);
  }

  GetCSUserList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetCSUserList', data);
  }

  SubmitUserList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/SubmitUserList', data);
  }

  SubmitRepeatCrewSchedule(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/SubmitRepeatCrewSchedule', data);
  }

  GetShiftNowByPlantOrLine(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl + 'CrewSchedule/GetShiftNowByPlantOrLine', data);
  }
}
